import ApiCore from "../utilities/core";

const url = 'b2s-settings';
const plural = 'b2s-settings';
const single = 'b2s-settings';

// plural and single may be used for message logic if needed in the ApiCore class.

export const apiSettings = new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    patch: true,
    delete: false,
    url: url,
    plural: plural,
    single: single,
    requireToken: true
});

apiSettings.massUpdate = () => {
    // Add custom api call logic here
}